import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';
import { useSessionStorage } from '../../../hooks/useSessionStorage';

import apiCategoriesCMS from '../../../api/Catalog/CategoryCMS';

import LinkLang from '../../Wraps/LinkLang';
import { ReactComponent as Arrow } from '../../../assets/icons/icon-arrow-down.svg';

const CategoryMenu = ({ categoryList, toggle, spanish }) => (
  <div className={styles.list} onMouseLeave={toggle}>
    {categoryList?.map((item, key) => (
      <LinkLang
        key={key}
        to={`/category/${item?.SLUG}`}
        state={{
          categoryId: item?.categoryID,
          categoryName: spanish ? item?.NameSpanish : item?.NameEnglish,
        }}
      >
        {spanish ? item?.NameSpanish : item?.NameEnglish}
      </LinkLang>
    ))}
  </div>
);
const ProductMenu = ({ productList, toggle }) => (
  <div className={styles.list} onMouseLeave={toggle}>
    {productList?.products?.map((item, key) => (
      <LinkLang
        key={key}
        to={`/product/${item?.SLUG}`}
        state={{ sku: item?.SKU }}
      >
        {item?.Name}
      </LinkLang>
    ))}
  </div>
);

const Breadcrumb = ({ cmsData, spanish }) => {
  const [categoryList, setCategoryList] = useSessionStorage(
    'cmsCategories',
    []
  );
  const [categoryMenu, setCategoryMenu] = useState(false);
  const [productMenu, setProductMenu] = useState(false);
  useEffect(async () => {
    const data =
      categoryList.length > 0
        ? categoryList
        : await apiCategoriesCMS.getCategories();
    setCategoryList(data);
  }, []);
  const toggleCategoryMenu = () => {
    setCategoryMenu(!categoryMenu);
    setProductMenu(false);
  };
  const toggleProductMenu = () => {
    setProductMenu(!productMenu);
    setCategoryMenu(false);
  };
  const currentCategory = cmsData?.categories[0];
  const getFromList = categoryList
    ? categoryList.find(
        (item) => item?.categoryID === currentCategory?.categoryID
      )
    : [];
  return (
    <>
      {cmsData && categoryList && getFromList && (
        <div className={styles.container}>
          <div className={styles.menu}>
            <button
              type="button"
              className={styles.trigger}
              onClick={toggleCategoryMenu}
            >
              <p>
                {spanish
                  ? currentCategory?.NameSpanish
                  : currentCategory?.NameEnglish}
              </p>
              <Arrow />
            </button>
            {categoryMenu ? (
              <CategoryMenu
                categoryList={categoryList}
                toggle={toggleCategoryMenu}
                spanish={spanish}
              />
            ) : (
              ''
            )}
          </div>
          <p className={styles.slash}>/</p>
          <div className={styles.menu}>
            <button
              type="button"
              className={styles.trigger}
              onClick={toggleProductMenu}
            >
              <p className={styles.product}>{cmsData?.Name}</p>
              <Arrow />
            </button>
            {productMenu ? (
              <ProductMenu
                productList={getFromList}
                toggle={toggleProductMenu}
              />
            ) : (
              ''
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Breadcrumb;
